import React from "react";
import Footermain from "./Footermain";

const Footer = () => {
  return (
    <div >
      <Footermain></Footermain>
      
      
     </div>
  );
};

export default Footer;
